Alerts = require 'app/scripts/views/lib/alerts'
ApiError = require 'app/scripts/network/api-error'
ApiPromise = require 'app/scripts/network/api-promise'
localizeServerError = require 'app/scripts/lib/localize-server-error'
PopOver = require 'app/scripts/views/lib/pop-over'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('invite_add_name')
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'

extractFullName = (email) ->
  puncSpacePattern = /[\s\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/
  puncPattern = /[\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/

  fullName = _.compact(Util.removeDomainFromEmailAddress(email).split(puncSpacePattern)).join(' ').replace(puncPattern, '')
  Util.toTitleCase(fullName)

validateFullName = (fullName) ->
  !Util.validName(fullName)

module.exports = class extends React.Component
  displayName: 'InviteAddName'

  constructor: (props) ->
    super(props)

    fullName = extractFullName(@props.email)

    @state = {
      err: validateFullName(fullName)
      fullName
    }

  UNSAFE_componentWillReceiveProps: ({ email }) ->
    fullName = extractFullName(email)

    @setState {
      err: validateFullName(fullName)
      fullName
    }

  render: t.renderable ->
    { email, model, modelCache } = @props
    { err, fullName, submitting } = @state

    toggleErrClass = if err then '' else '.hide'

    t.div { style: { marginTop: '10px' } }, =>
      t.p '.quiet', ->
        t.format 'we dont know that person…team', { email }

      t.p ".error#{toggleErrClass}", ->
        t.format 'full name too short'

      t.form { @onSubmit }, =>
        t.label ->
          t.format 'full-name'
        t.input { type: 'text', value: fullName, onChange: @onNameChange }
        t.input '.wide.primary', { type: 'submit', disabled: submitting, value: t.l('send') }

  onNameChange: ({ target }) =>
    fullName = target.value

    @setState {
      err: validateFullName(fullName.trim())
      fullName
    }

  onSubmit: (e) =>
    e.preventDefault()

    { err } = @state

    if !err
      @sendEmailInvite()

  sendEmailInvite: =>
    { email, member, model, modelCache } = @props
    { fullName } = @state

    data = { fullName, email, type: 'normal' }

    @setState submitting: true

    model.addMembers(data)
    .then (grouped) =>
      added = grouped[grouped._categories.ADDED]
      errors = _.omit(grouped, grouped._categories.ADDED)

      for entries of added
        track("Invitations", "Send Email Org Invite to New Member", "Role: #{data.type}")
      PopOver.hide()
    .finally =>
      @setState submitting: false
    .catch ApiError, @_handleError

  _handleError: (resOrApiError) =>
    message = localizeServerError(resOrApiError)

    Alerts.showLiteralText(message, 'error', 'alert', 3000)
    track("Invitations", "Error: #{ resOrApiError.message ? resOrApiError.responseText }")
